import SparkMD5 from 'spark-md5';

export const readBlobs = (blobs) => {
    return Promise.all(blobs.map(blob => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        
        reader.onload = () => {
          const arrayBuffer = reader.result;
          const md5 = SparkMD5.ArrayBuffer.hash(arrayBuffer);
          resolve({
            arrayBuffer,
            md5,
          });
        };
  
        reader.onerror = reject;
      });
    }));
  };

export default readBlobs;
